// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DHDO","textarea":"styles_textarea__2w_K7"};